import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { c } from 'ttag';
import Icon from '../Icon/Icon';
const VaultNameBadge = ({ vault }) => {
    return (_jsxs("div", { title: c('B2.NavSharedUI.Label').t `Vault name`, className: "flex select-none items-center rounded border border-passive-2 px-1.5 py-1", children: [_jsx(Icon, { ariaLabel: c('B2.NavSharedUI.Label').t `Shared in vault`, type: vault.iconString, className: "mr-1", size: "medium", emojiSize: "small" }), _jsx("span", { className: "mr-auto overflow-hidden text-ellipsis text-sm font-semibold lg:text-xs", children: vault.name })] }));
};
export default VaultNameBadge;
